# frozen_string_literal: true

module Engine
  module Game
    module G1877StockholmTramways
    end
  end
end
